import React from "react";
import PropTypes from "prop-types";
import { BsFillPersonFill } from "react-icons/bs";

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

  /* Own message bubble */
  .msg-own {
    background: rgba(34, 211, 238, 0.12);
    border: 1px solid rgba(34, 211, 238, 0.20);
    border-radius: 14px 14px 4px 14px;
    padding: 10px 14px;
    max-width: 75%;
    font-family: 'Inter', system-ui, sans-serif;
  }

  /* Other message bubble */
  .msg-other {
    background: #162035;
    border: 1px solid #1e2d4a;
    border-radius: 14px 14px 14px 4px;
    padding: 10px 14px;
    max-width: 75%;
    font-family: 'Inter', system-ui, sans-serif;
  }

  .msg-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 5px;
  }

  .msg-name {
    font-size: 11.5px;
    font-weight: 600;
    color: #8b9dc3;
    white-space: nowrap;
  }

  .msg-time {
    font-size: 11px;
    color: #4a5f82;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .msg-text {
    font-size: 13.5px;
    color: #dbe4f8;
    line-height: 1.55;
    word-break: break-word;
  }

  /* Avatar */
  .msg-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(34, 211, 238, 0.10);
    border: 1px solid rgba(34, 211, 238, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #22d3ee;
    font-size: 16px;
    flex-shrink: 0;
  }
`;

let _inj = false;
const inject = () => {
  if (_inj) return;
  const s = document.createElement("style");
  s.textContent = STYLES;
  document.head.appendChild(s);
  _inj = true;
};

const MessageComponent = ({
  userName,
  sentTime,
  textMessage,
  isOwnMessage,
}) => {
  inject();

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginBottom: "14px",
        alignItems: "flex-end",
        flexDirection: isOwnMessage ? "row-reverse" : "row",
      }}
    >
      {/* Avatar */}
      <div className="msg-avatar">
        <BsFillPersonFill />
      </div>

      {/* Bubble */}
      <div className={isOwnMessage ? "msg-own" : "msg-other"}>
        <div className="msg-meta">
          <span className="msg-name">{isOwnMessage ? "You" : userName}</span>
          <span className="msg-time">{sentTime}</span>
        </div>
        <div className="msg-text">{textMessage}</div>
      </div>
    </div>
  );
};

MessageComponent.propTypes = {
  userName: PropTypes.any,
  sentTime: PropTypes.any,
  textMessage: PropTypes.any,
  isOwnMessage: PropTypes.any,
};

export default MessageComponent;
